"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var randombytes = require("randombytes");
function getRandomBytes(bytes) {
  return new Promise(function (resolve, reject) {
    randombytes(bytes, function (err, resp) {
      if (err) {
        reject(err);
        return;
      }
      resolve(resp);
    });
  });
}
exports.getRandomBytes = getRandomBytes;
function getRandomBytesSync(bytes) {
  return randombytes(bytes);
}
exports.getRandomBytesSync = getRandomBytesSync;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxJQUFNQSxXQUFXLEdBQUdDLE9BQU8sQ0FBQyxhQUFhLENBQUM7QUFFMUMsU0FBZ0JDLGNBQWMsQ0FBQ0MsS0FBYTtFQUMxQyxPQUFPLElBQUlDLE9BQU8sQ0FBQyxVQUFDQyxPQUFPLEVBQUVDLE1BQU07SUFDakNOLFdBQVcsQ0FBQ0csS0FBSyxFQUFFLFVBQVNJLEdBQVEsRUFBRUMsSUFBWTtNQUNoRCxJQUFJRCxHQUFHLEVBQUU7UUFDUEQsTUFBTSxDQUFDQyxHQUFHLENBQUM7UUFDWDs7TUFHRkYsT0FBTyxDQUFDRyxJQUFJLENBQUM7SUFDZixDQUFDLENBQUM7RUFDSixDQUFDLENBQUM7QUFDSjtBQVhBQztBQWFBLFNBQWdCQyxrQkFBa0IsQ0FBQ1AsS0FBYTtFQUM5QyxPQUFPSCxXQUFXLENBQUNHLEtBQUssQ0FBQztBQUMzQjtBQUZBTSIsIm5hbWVzIjpbInJhbmRvbWJ5dGVzIiwicmVxdWlyZSIsImdldFJhbmRvbUJ5dGVzIiwiYnl0ZXMiLCJQcm9taXNlIiwicmVzb2x2ZSIsInJlamVjdCIsImVyciIsInJlc3AiLCJleHBvcnRzIiwiZ2V0UmFuZG9tQnl0ZXNTeW5jIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9yYW5kb20udHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=